"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goToConference = void 0;
const server_1 = require("../../../server");
const account_1 = require("../../base/account");
const meetmateTrust_1 = require("../../base/layout/meetmateTrust");
// (Action) Enter 회의실 입장
const goToConference = async (id, text) => {
    let popup;
    try {
        const token = (0, account_1.getAccessToken)(APP.store.getState);
        const url = `/api/mimac/v1/conferences/${id}/attend-page?token=${encodeURIComponent(token)}`;
        popup = window.open(url, 'popupPage', 'directories=no,titlebar=no,toolbar=no,status=no,menubar=no,location=yes,width=1920,height=964,scrollbars=yes');
        if (!popup) {
            throw new Error('Popup was blocked');
        }
        // meetmate 팝업 신원 등록 — 이후 이 팝업의 postMessage 는 도메인과 무관하게 신뢰(meetmateTrust 레이어 1)
        (0, meetmateTrust_1.registerMeetmatePopup)(popup);
        popup.focus();
    }
    catch (error) {
        if (text === 'live') {
            await (0, server_1.quitEnquiriesList)(id);
        }
        alert('팝업이 차단되어있습니다. 팝업 허용 후 다시 시도해주세요.');
        popup && popup.close();
    }
};
exports.goToConference = goToConference;
